
export const buildSelectedElementData = (element) => 
{
    let elementType = "";
    let elementID = element.key;
    let elementName = "";
    let elementNodeType = null;
    let elementSecondaryTypeName = null;
    let elementGroupKey = null;
    let basicData = {};
    let paramsData = {};
    let materialsData = {};

    let elementData = 
    {
        elementType:elementType,
        elementID:elementID,
        elementName:elementName,
        elementNodeType:elementNodeType,
        elementSecondaryTypeName:elementSecondaryTypeName,
        elementGroupKey:elementGroupKey,
        basicData:basicData,
        paramsData:paramsData,
        materialsData:materialsData,
    };

    //判断选中项类型
    if(element.nodeName)
    {
        elementType = "node";
        elementName = element.nodeName;
        elementNodeType = element.type;
        elementSecondaryTypeName = element.elementName;
        elementGroupKey = element.group ? String(element.group) : "无";
    }
    else if(element.linkName)
    {
        elementType = "link";
        elementName = element.linkName;
        elementGroupKey = element.group[0] ? String(element.group[0]) : "无";
    }
    else if(element.isGroup)
    {
        elementType = "group";
        elementName = element.groupName;
    }
    else
    {
        return elementData;
    }

    if(elementType==="node")
    {
        //元件基础参数
        basicData = 
        {
            "元件名称":{value:element.nodeName,engName:"nodeName",show:true},
            "物性计算方法":{value:element.physical_method,engName:"physical_method",show:true,enum:[{label:"NRTL",value:"NRTL"},{label:"SRK",value:"SRK"}]},
            "相态":{value: element.phase,engName:"phase",show:true,enum:[{label:"L-液相",value:"L"},{label:"V-汽相",value:"V"},{label:"VL-汽液两相",value:"VL"}]},
            "计算模式":{value:element.mode,engName:"mode",show:true,enum:[{label:"TP-温压闪蒸",value:"TP"},{label:"VP-汽化率压力闪蒸",value:"VP"},{label:"HP-压焓闪蒸",value:"HP"}]},
            "描述":{value:element.description,engName:"description",show:false}
        };

        //元件参数
        paramsData = element.ParamValues;
    }
    else if(elementType==="link")
    {
        //流股基础参数
        basicData = 
        {
            "流股名称":{value:element.linkName,engName:"linkName",show:true},
            "描述":{value:element.description,engName:"description",show:false}
        };

        //流股参数
        paramsData = element.ParamValues;

        //流股组分参数
        materialsData = element.materials;
    }
    else if(elementType==="group")
    {
        //分组基础参数
        basicData = 
        {
            "分组名称":{value:element.groupName,engName:"groupName",show:true},
            "描述":{value:element.description,engName:"description",show:false}
        };

        //分组参数
        paramsData = element.ParamValues;
    }

    elementData = 
    {
        elementType:elementType,
        elementID:elementID,
        elementName:elementName,
        elementNodeType:elementNodeType,
        elementSecondaryTypeName:elementSecondaryTypeName,
        elementGroupKey:elementGroupKey,
        basicData:basicData,
        paramsData:paramsData,
        materialsData:materialsData,
    };
    return elementData;
}